var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#286795"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#FFF",
    strokeOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.667 13.333v4.166c0 .934.308 1.8.833 2.5h-5a4.12 4.12 0 0 0 .834-2.5v-4.166zm2.5-1.667h-8.333a.836.836 0 0 0-.834.833c0 .459.375.834.834.834h.833v4.166c0 1.384-1.117 2.5-2.5 2.5v1.667h4.975v5.833l.833.834.834-.834v-5.833h5.025v-1.667a2.497 2.497 0 0 1-2.5-2.5v-4.166h.833a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.292adb1149d4692913f35f8d40f0b99d.svg";
export { ForwardRef as ReactComponent };